import React, { useCallback } from 'react';
import { browser } from '@atlaskit/editor-common/utils';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
import { hoverCell, hoverRows, selectRow, selectRows } from '../../commands';
import { TableCssClassName as ClassName } from '../../types';
import { CornerControls, DragCornerControls, DragCornerControlsWithSelection } from './CornerControls';
import { FloatingControlsWithSelection } from './FloatingControlsWithSelection';
import NumberColumn from './NumberColumn';
import { DragControls, RowControls } from './RowControls';
export var TableFloatingControls = function TableFloatingControls(_ref) {
  var editorView = _ref.editorView,
    tableRef = _ref.tableRef,
    tableNode = _ref.tableNode,
    isInDanger = _ref.isInDanger,
    isResizing = _ref.isResizing,
    isNumberColumnEnabled = _ref.isNumberColumnEnabled,
    isHeaderRowEnabled = _ref.isHeaderRowEnabled,
    isHeaderColumnEnabled = _ref.isHeaderColumnEnabled,
    tableActive = _ref.tableActive,
    hasHeaderRow = _ref.hasHeaderRow,
    hoveredRows = _ref.hoveredRows,
    stickyHeader = _ref.stickyHeader,
    isDragAndDropEnabled = _ref.isDragAndDropEnabled,
    hoveredCell = _ref.hoveredCell,
    isTableHovered = _ref.isTableHovered,
    tableWrapperWidth = _ref.tableWrapperWidth,
    api = _ref.api;
  var _selectRow = useCallback(function (row, expand) {
    var state = editorView.state,
      dispatch = editorView.dispatch;
    // fix for issue ED-4665
    if (browser.ie_version === 11) {
      editorView.dom.blur();
    }
    selectRow(row, expand)(state, dispatch);
  }, [editorView]);
  var _selectRows = useCallback(function (rowIndexes) {
    var state = editorView.state,
      dispatch = editorView.dispatch;
    // fix for issue ED-4665
    if (browser.ie_version === 11) {
      editorView.dom.blur();
    }
    selectRows(rowIndexes)(state, dispatch);
  }, [editorView]);
  var _hoverRows = useCallback(function (rows, danger) {
    var state = editorView.state,
      dispatch = editorView.dispatch;
    hoverRows(rows, danger)(state, dispatch);
  }, [editorView]);

  // re-use across numbered columns and row controls
  var updateCellHoverLocation = useCallback(function (rowIndex) {
    var state = editorView.state,
      dispatch = editorView.dispatch;
    if (tableActive) {
      // For context:  Whenever we mouse over a column or row drag handle, we will ALWAYS be hovering over the 0 index
      // of the opposite dimension. For example; here when we mouse over the row drag handle then we're technically
      // also hovering over column 0 index. And vice-versa with columns. This means we don't need to worry about knowing the
      // current column index. We can just force it to 0.
      hoverCell(rowIndex, 0)(state, dispatch);
    }
  }, [editorView, tableActive]);
  if (!tableRef) {
    return null;
  }
  var stickyTop = stickyHeader && stickyHeader.sticky && hasHeaderRow ? stickyHeader.top : undefined;
  var wrapperClassName = isDragAndDropEnabled ? ClassName.DRAG_ROW_CONTROLS_WRAPPER : ClassName.ROW_CONTROLS_WRAPPER;
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName
  }, /*#__PURE__*/React.createElement("div", {
    onMouseDown: function onMouseDown(e) {
      return !isDragAndDropEnabled && e.preventDefault();
    }
  }, isNumberColumnEnabled ? /*#__PURE__*/React.createElement(NumberColumn, {
    editorView: editorView,
    hoverRows: _hoverRows,
    tableRef: tableRef,
    tableActive: tableActive,
    hoveredRows: hoveredRows,
    hasHeaderRow: hasHeaderRow,
    isInDanger: isInDanger,
    isResizing: isResizing,
    selectRow: _selectRow,
    updateCellHoverLocation: updateCellHoverLocation,
    stickyTop: stickyTop,
    isDragAndDropEnabled: isDragAndDropEnabled
  }) : null, tableActive && /*#__PURE__*/React.createElement(React.Fragment, null, isDragAndDropEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, getBooleanFF('platform.editor.table.use-shared-state-hook') ? /*#__PURE__*/React.createElement(DragCornerControlsWithSelection, {
    editorView: editorView,
    tableRef: tableRef,
    isInDanger: isInDanger,
    isResizing: isResizing,
    api: api
  }) : /*#__PURE__*/React.createElement(DragCornerControls, {
    editorView: editorView,
    tableRef: tableRef,
    isInDanger: isInDanger,
    isResizing: isResizing
  }), /*#__PURE__*/React.createElement(DragControls, {
    tableRef: tableRef,
    tableNode: tableNode,
    hoveredCell: hoveredCell,
    isTableHovered: isTableHovered,
    editorView: editorView,
    tableActive: tableActive,
    isInDanger: isInDanger,
    isResizing: isResizing,
    tableWidth: tableWrapperWidth,
    hoverRows: _hoverRows,
    selectRow: _selectRow,
    selectRows: _selectRows,
    updateCellHoverLocation: updateCellHoverLocation
  })) : getBooleanFF('platform.editor.table.use-shared-state-hook') ? /*#__PURE__*/React.createElement(FloatingControlsWithSelection, {
    editorView: editorView,
    tableRef: tableRef,
    isInDanger: isInDanger,
    isResizing: isResizing,
    isHeaderRowEnabled: isHeaderRowEnabled,
    isHeaderColumnEnabled: isHeaderColumnEnabled,
    hoveredRows: hoveredRows,
    stickyTop: tableActive ? stickyTop : undefined,
    tableActive: tableActive,
    hoverRows: _hoverRows,
    selectRow: _selectRow,
    api: api
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CornerControls, {
    editorView: editorView,
    tableRef: tableRef,
    isInDanger: isInDanger,
    isResizing: isResizing,
    isHeaderRowEnabled: isHeaderRowEnabled,
    isHeaderColumnEnabled: isHeaderColumnEnabled,
    hoveredRows: hoveredRows,
    stickyTop: tableActive ? stickyTop : undefined
  }), /*#__PURE__*/React.createElement(RowControls, {
    editorView: editorView,
    tableRef: tableRef,
    hoverRows: _hoverRows,
    hoveredRows: hoveredRows,
    isInDanger: isInDanger,
    isResizing: isResizing,
    selectRow: _selectRow,
    stickyTop: tableActive ? stickyTop : undefined
  })))));
};
export default TableFloatingControls;